import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { InputNumberModule } from 'primeng/inputnumber';
import { ReactiveFormsModule } from '@angular/forms';
import { ErrorComponent } from '../../../error/error.component';
import { ActivityFormService } from 'src/app/trip-calculator/services/activity-form.service';

@Component({
  selector: 'app-passenger-form',
  imports: [
    TranslocoPipe,
    InputNumberModule,
    ErrorComponent,
    ReactiveFormsModule,
  ],
  templateUrl: './passenger-form.component.html',
})
export class PassengerFormComponent implements OnInit, OnDestroy {
  activityFormService = inject(ActivityFormService);
  ngOnInit() {
    this.activityFormService.createPeoplePerVehicleControl();
  }
  ngOnDestroy() {
    this.activityFormService.destroyPeoplePerVehicleControl();
  }
}
